<template>
  <CommonPopup
    :title="t('meu.quit.Title')"
    cancelBtn
    horizental
    :confirmText="t('meu.Logout')"
    :onConfirm="logout"
    :cancelText="$t('Common.Cancel')">
      <img src="@a/assets/images/i_alert.png" class="size-15 my-4" alt=""/>
      <p class="text-14 font-[500] leading-20 text-center">
        {{ $t('meu.quit.QuitTips') }}
      </p>
  </CommonPopup>
</template>

<script setup lang="ts">
  import CommonPopup from '@a/components/commonPopup/index.vue'
  import { useUserInfo, useWallet } from '@/store'
  import { logout as logoutApi } from '@/api/login'
  import i18n from "@/i18n";
  const t = i18n.global.t;
  const router = useRouter()
  const logout = async () => {
    showLoadingToast(t('meu.quit.Senna'));
    const { code } = await logoutApi()
    if (code === 1) {
      showToast({
        type: 'success',
        iconSize: 30,
        message: 'sucesso',
        onClose: () => {
          useUserInfo().logout()
          useWallet().reset()
          router.replace('/')
        }
      })
    }
  }
</script>
